// extracted by mini-css-extract-plugin
module.exports = {"moviesGrid":"MoviesGrid_moviesGrid__1gKyA"};